import styles from "./context-menu.module.css";

import { forwardRef, useMemo } from "react";
import { Dropdown } from "antd";

import DotsVerticalIcon from "@/icons/DotsVerticalIcon";
import EyeIcon from "@/icons/EyeIcon";
import PencilAltIcon from "@/icons/PencilAltIcon";
import TrashIcon from "@/icons/TrashIcon";
import PlusSquareIcon from "@/icons/PlusSquareIcon";
import DotsHorizontalIcon from "@/icons/DotsHorizontalIcon";
import ClipboardCheckIcon from "@/icons/ClipboardCheckIcon";
import DuplicateIcon from "@/icons/DuplicateIcon";
import CheckIcon from "@/icons/CheckIcon";
import LinkIcon from "@/icons/LinkIcon";

// Универсальное контекстное меню
// Используется на любой странице с таблицами и в карточках
// Позволяет выполнять основные действия с элементами таблицы
// Меняет иконку [...] в зависимости от переданного параметра vertical
const ContextMenu = forwardRef(
  (
    {
      onView,
      onEdit,
      onDelete,
      onAdd,
      onPublish,
      onCopy,
      onCopyLink,
      onSelectItem,
      selectItemText = "Выделить",
      onRemoveFromSprint,
      removeFromSprintText = "Удалить из спринта",
      items,
      vertical = false,
      trigger = ["click"],
    },
    ref,
  ) => {
    const defaultItems = useMemo(() => {
      const topItems = [
        {
          key: "view",
          onClick: onView,
          label: (
            <div className={styles.menuItem}>
              <EyeIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Просмотр
            </div>
          ),
        },
        {
          key: "copy",
          onClick: onCopy,
          label: (
            <div className={styles.menuItem}>
              <DuplicateIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Копировать
            </div>
          ),
        },
        {
          key: "copy_link",
          onClick: onCopyLink,
          label: (
            <div className={styles.menuItem}>
              <LinkIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Скопировать ссылку
            </div>
          ),
        },
        {
          key: "edit",
          onClick: onEdit,
          label: (
            <div className={styles.menuItem}>
              <PencilAltIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Редактировать
            </div>
          ),
        },
        {
          key: "add",
          onClick: onAdd,
          label: (
            <div className={styles.menuItem}>
              <PlusSquareIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Добавить
            </div>
          ),
        },
        {
          key: "publish",
          onClick: onPublish,
          label: (
            <div className={styles.menuItem}>
              <ClipboardCheckIcon style={{ fontSize: 16, color: "#e66a25" }} />
              Опубликовать
            </div>
          ),
        },
        {
          key: "select",
          onClick: onSelectItem,
          label: (
            <div className={styles.menuItem}>
              <CheckIcon style={{ fontSize: 16, color: "#e66a25" }} />
              {selectItemText}
            </div>
          ),
        },
        {
          key: "remove_from_sprint",
          onClick: onRemoveFromSprint,
          label: (
            <div className={styles.menuItem}>
              <TrashIcon style={{ fontSize: 16, color: "#e66a25" }} />
              {removeFromSprintText}
            </div>
          ),
        },
      ].filter(({ onClick }) => onClick);

      const deleteItem = onDelete
        ? {
            key: "delete",
            onClick: onDelete,
            label: (
              <div className={styles.menuItem}>
                <TrashIcon style={{ fontSize: 16, color: "#e66a25" }} />
                Удалить
              </div>
            ),
          }
        : null;

      if (!deleteItem) return topItems;

      return topItems.length
        ? [
            ...topItems,
            {
              key: "divider",
              type: "divider",
            },
            deleteItem,
          ]
        : [deleteItem];
    }, [
      onView,
      onEdit,
      onDelete,
      onAdd,
      onPublish,
      onCopy,
      onCopyLink,
      onSelectItem,
      selectItemText,
      onRemoveFromSprint,
      removeFromSprintText,
    ]);

    // если передали items
    const actualItems = items ?? defaultItems;

    return (
      <div ref={ref}>
        <Dropdown
          menu={{ items: actualItems }}
          trigger={trigger}
          placement="bottomRight"
        >
          <span className={styles.trigger}>
            {vertical ? (
              <DotsVerticalIcon style={{ fontSize: 18 }} />
            ) : (
              <DotsHorizontalIcon style={{ fontSize: 18 }} />
            )}
          </span>
        </Dropdown>
      </div>
    );
  },
);

export default ContextMenu;
